import {trim} from "es-toolkit";

import {useI18n} from "vue-i18n";
import {useRuntimeConfig} from "nuxt/app";

export function useSeoUrl() {
	const config = useRuntimeConfig();
	const {t} = useI18n({
		useScope: "global",
	});

	const useUrl = (url?: string | null): string => {
		if (!url || url.length === 0) {
			return "";
		}

		return `${config.public.appUrl}/${t("storyblok.product")}/${trim(url, "/")}`;
	};
	return {
		useUrl,
	};
}
